<template>

     <div class="fl-post-grid-content">

        <p v-if="parseInt(moduleSettings.show_content) === 1">{{strippedContent}}</p>

        <a
            v-if="parseInt(moduleSettings.show_more_link) == 1"
            class="fl-post-grid-more"
            :href="postObj.link"
            :target="hrefTarget"
            >
            {{moduleSettings.more_link_text}}
        </a>

        </div>

</template>

<script>
export default {
  props: {
    postObj: {
      type: Object
    },
    moduleSettings: {
      type: Object
    },
    hrefTarget: {
      type: String
    }
  },
  computed: {
    strippedContent: function () {
      return this.postObj.content.replace(/(<([^>]+)>)/ig, '')
    }
  }
}
</script>
